document.addEventListener('DOMContentLoaded', function() {
  fetch('https://api.vimeo.com/users/30452144/albums/7669939/videos', {
        headers: {
            'Authorization': 'bearer bf04e67ba612bc5df1e342fcdb4b117f'
        }
    })
    .then(response => response.json())
    .then(data => {
        console.log(data);
    });
})